var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPpvSettings01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PPV Settings") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.08,29.7V47.79a3,3,0,0,0,3,3H45.41a3,3,0,0,0,3-3V29.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 13.31,
    cy: 21.2,
    r: 6.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 29.75,
    cy: 17.25,
    r: 6.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 46.09,
    cy: 21.2,
    r: 6.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 14.34,
    y1: 45.72,
    x2: 31.59,
    y2: 45.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 36.38,
    y1: 45.72,
    x2: 45.01,
    y2: 45.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.51,
    y: 43.33,
    width: 2.88,
    height: 4.79,
    rx: 1.44
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,25.7V24.48l.17.16a4.26,4.26,0,0,1-1.3-.2,2.88,2.88,0,0,1-1.07-.6l.28-.63a3.26,3.26,0,0,0,1,.55,3.59,3.59,0,0,0,1.19.18,1.92,1.92,0,0,0,1.23-.32,1,1,0,0,0,.4-.83.81.81,0,0,0-.29-.65,2.42,2.42,0,0,0-1-.39l-1-.2a2.52,2.52,0,0,1-1.3-.63A1.58,1.58,0,0,1,11,19.77a1.87,1.87,0,0,1,.27-1,2,2,0,0,1,.77-.69,2.81,2.81,0,0,1,1.14-.28l-.12.14v-1.2h.65v1.2l-.12-.14a3.23,3.23,0,0,1,1,.22,2.32,2.32,0,0,1,.89.61l-.26.61a2.4,2.4,0,0,0-.86-.57,2.87,2.87,0,0,0-1-.18,1.8,1.8,0,0,0-1.16.35,1.1,1.1,0,0,0-.43.91,1,1,0,0,0,.27.71,1.72,1.72,0,0,0,.89.39l1,.21a3,3,0,0,1,1.38.6,1.41,1.41,0,0,1,.45,1.1,1.69,1.69,0,0,1-.28.95,1.91,1.91,0,0,1-.76.64,2.93,2.93,0,0,1-1.11.28l.15-.16V25.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.54,21.39V20.17l.17.16a4.26,4.26,0,0,1-1.3-.2,3.19,3.19,0,0,1-1.07-.6l.28-.64a3.3,3.3,0,0,0,1,.56,3.59,3.59,0,0,0,1.19.18A2,2,0,0,0,31,19.31a1,1,0,0,0,.4-.83.81.81,0,0,0-.29-.65,2.16,2.16,0,0,0-1-.39l-1-.2a2.52,2.52,0,0,1-1.29-.63,1.6,1.6,0,0,1-.42-1.16,1.84,1.84,0,0,1,.27-1,2,2,0,0,1,.76-.69,2.74,2.74,0,0,1,1.14-.28l-.11.13V12.43h.65v1.19l-.12-.13a3.23,3.23,0,0,1,1,.22,2.2,2.2,0,0,1,.89.6l-.27.62a2.13,2.13,0,0,0-.85-.57,2.87,2.87,0,0,0-1-.18,1.8,1.8,0,0,0-1.16.34,1.11,1.11,0,0,0-.43.91,1,1,0,0,0,.27.71,1.8,1.8,0,0,0,.89.4l1,.21a2.86,2.86,0,0,1,1.38.6,1.39,1.39,0,0,1,.45,1.09,1.69,1.69,0,0,1-.27,1,2,2,0,0,1-.76.64,2.93,2.93,0,0,1-1.11.28l.15-.16v1.23Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17,40.41V31h3.85a3.31,3.31,0,0,1,2.29.72,2.84,2.84,0,0,1,0,4,3.26,3.26,0,0,1-2.29.73H18.12v4Zm1.11-5h2.63A2.29,2.29,0,0,0,22.31,35a1.92,1.92,0,0,0,0-2.65,2.29,2.29,0,0,0-1.56-.47H18.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.74,40.41V31h3.85a3.35,3.35,0,0,1,2.3.72,2.86,2.86,0,0,1,0,4,3.31,3.31,0,0,1-2.3.73H26.86v4Zm1.12-5h2.62A2.34,2.34,0,0,0,31.05,35a1.92,1.92,0,0,0,0-2.65,2.34,2.34,0,0,0-1.57-.47H26.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.45,40.41,33.33,31h1.2l3.66,8.57h-.41L41.47,31h1.15l-4.15,9.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.88,25.7V24.48l.17.16a4.26,4.26,0,0,1-1.3-.2,3,3,0,0,1-1.08-.6l.29-.63a3.26,3.26,0,0,0,1,.55,3.55,3.55,0,0,0,1.19.18,1.87,1.87,0,0,0,1.22-.32,1,1,0,0,0,.41-.83.81.81,0,0,0-.29-.65,2.42,2.42,0,0,0-1-.39l-1-.2a2.52,2.52,0,0,1-1.29-.63,1.58,1.58,0,0,1-.42-1.15,1.87,1.87,0,0,1,.27-1,2,2,0,0,1,.76-.69A2.9,2.9,0,0,1,46,17.8l-.11.14v-1.2h.65v1.2l-.12-.14a3.29,3.29,0,0,1,1,.22,2.32,2.32,0,0,1,.89.61l-.27.61a2.36,2.36,0,0,0-.85-.57,2.87,2.87,0,0,0-1-.18,1.78,1.78,0,0,0-1.16.35,1.1,1.1,0,0,0-.43.91,1,1,0,0,0,.27.71,1.72,1.72,0,0,0,.88.39l1,.21a3,3,0,0,1,1.38.6,1.41,1.41,0,0,1,.45,1.1,1.68,1.68,0,0,1-.27.95,1.91,1.91,0,0,1-.76.64,2.93,2.93,0,0,1-1.11.28l.15-.16V25.7Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 9.96,
    y1: 10.14,
    x2: 9.96,
    y2: 12.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.67,
    y1: 10.14,
    x2: 16.67,
    y2: 12.45
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.31,
    y1: 8.62,
    x2: 13.31,
    y2: 10.94
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.4,
    y1: 6.3,
    x2: 26.4,
    y2: 8.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 33.11,
    y1: 6.3,
    x2: 33.11,
    y2: 8.62
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 29.75,
    y1: 4.79,
    x2: 29.75,
    y2: 7.11
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 42.74,
    y1: 11.09,
    x2: 42.74,
    y2: 13.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.45,
    y1: 11.09,
    x2: 49.45,
    y2: 13.41
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 46.09,
    y1: 9.58,
    x2: 46.09,
    y2: 11.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpvSettings01);
export default __webpack_public_path__ + "static/media/PPV_Settings_01.ad9ae6263f66812da0a9969d2440155a.svg";
export { ForwardRef as ReactComponent };